'use client';

import React from 'react';
import { styled } from '@linaria/react';

import { TIMING_FUNCTIONS } from './css-transitions.constants';

const BOX_HEIGHT = 50;
const BOX_PADDING = 32;

const easeIn = TIMING_FUNCTIONS['ease-in-mega'];
const easeOut = TIMING_FUNCTIONS['ease-out-mega'];

const easeInCurve = `cubic-bezier(
  ${easeIn.p1[0]}, ${easeIn.p1[1]},
  ${easeIn.p2[0]}, ${easeIn.p2[1]}
)`;
const easeOutCurve = `cubic-bezier(
  ${easeOut.p1[0]}, ${easeOut.p1[1]},
  ${easeOut.p2[0]}, ${easeOut.p2[1]}
)`;

function EnteringAndExiting({}) {
  const [isVisible, setIsVisible] = React.useState(false);

  const hiddenPosition = (BOX_HEIGHT + BOX_PADDING + 1) * -1;
  const duration = isVisible ? 500 : 250;

  return (
    <Wrapper>
      <Box
        style={{
          transform: `translateY(${
            isVisible ? 0 : hiddenPosition
          }px)`,
          transition: `transform ${duration}ms ${
            isVisible ? easeOutCurve : easeInCurve
          }`,
        }}
      />
      <Button onClick={() => setIsVisible(!isVisible)}>
        <Backdrop></Backdrop>
        <Contents>Trigger</Contents>
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  margin: 48px auto 64px;
  padding: 32px;
  border: 1px solid var(--color-gray-300);
  display: flex;
  align-items: center;
  flex-direction: column;
  /* Hide Box when it goes "offscreen" */
  overflow: hidden;
`;

const Box = styled.div`
  width: 50px;
  height: 50px;
  background: hsl(345deg, 100%, 47%);
  border-radius: 4px;
  will-change: transform;
`;

const Button = styled.button`
  position: relative;
  color: white;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
  font-size: 1.125rem;
  height: 60px;
  padding: 0 32px;
  font-weight: var(--font-weight-bold);
  margin-top: 32px;
`;

const Backdrop = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-primary);
  border-radius: 5px;
  transition: transform 250ms;
  will-change: transform;

  html[data-color-mode='dark'] & {
    background-color: var(--color-gray-200);
  }

  ${Button}:hover & {
    transform: scale(1.025);
    transition: transform 150ms;
  }
  ${Button}:active & {
    transform: scale(0.95);
    transition: transform 32ms;
  }
`;
const Contents = styled.span`
  position: relative;
`;

export default EnteringAndExiting;
